<div class="alert-large-footer">
  <brt-button [title]="text" [size]="'large'" [color]="'white'" (click)="onClosed.emit(true)"></brt-button>
</div>
